import { format } from 'date-fns';
import Meeting from './Meeting';
import { srLatn } from 'date-fns/locale';
import PropTypes from 'prop-types';

import './Calendar.css';

function MeetingsList({ selectedDayMeetings, selectedDay, animate }) {
  // todo: trenutno grupisano po useru, u koliko nema potrebe za tim odkomentarisati kod dole
  // todo: a zakomentarisati trenutni
  // todo: napraiti uslov za prikaz grupe ili bez grupe na osnovi prava pregleda

  const groupedMeetings = selectedDayMeetings.reduce((result, meeting) => {
    const { user } = meeting;
    if (!result[user]) {
      result[user] = [];
    }
    result[user].push(meeting);
    return result;
  }, {});

  return (
    <section className="meeting-list-wrapper">
      <h2 className="meeting-header">
        Aktivnosti za{' '}
        <time dateTime={format(selectedDay, 'yyyy-MM-dd')}>
          {format(selectedDay, 'MMMM dd, yyy', { locale: srLatn })}
        </time>
      </h2>
      <ol
        className={
          animate === true
            ? 'meeting-list meeting-list-animation'
            : 'meeting-list'
        }
      >
        {/* {selectedDayMeetings.length > 0 ? (
          selectedDayMeetings.map((meeting) => (
            <Meeting meeting={meeting} key={meeting.id} />
          ))
        ) : (
          <p>Nema aktivnosti.</p>
        )} */}
        {selectedDayMeetings.length > 0 ? (
          Object.keys(groupedMeetings).map((user) => (
            <div key={user}>
              <span className="user-group">{user}</span>
              {groupedMeetings[user].map((meeting) => (
                <Meeting key={meeting.id} meeting={meeting} />
              ))}
            </div>
          ))
        ) : (
          <p>Nema aktivnosti.</p>
        )}
      </ol>
    </section>
  );
}

export default MeetingsList;

MeetingsList.propTypes = {
  animate: PropTypes.bool, // u koliko hocemo da animiramo prikaz liste
  selectedDay: PropTypes.instanceOf(Date),
  selectedDayMeetings: PropTypes.array,
};
